const formats = {
  af: '%Y-%m-%d %H:%M',
  'af-ZA': '%Y-%m-%d %H:%M',
  ar: '%d/%m/yy %T',
  'ar-AE': '%d/%m/%Y %T',
  'ar-BH': '%d/%m/%Y %T',
  'ar-DZ': '%d-%m-%Y %H:%M',
  'ar-EG': '%d/%m/%Y %T',
  'ar-IQ': '%d/%m/%Y %T',
  'ar-JO': '%d/%m/%Y %T',
  'ar-KW': '%d/%m/%Y %T',
  'ar-LB': '%d/%m/%Y %T',
  'ar-LY': '%d/%m/%Y %T',
  'ar-MA': '%d-%m-%Y %H:%M',
  'ar-OM': '%d/%m/%Y %T',
  'ar-QA': '%d/%m/%Y %T',
  'ar-SA': '%d/%m/yy %T',
  'ar-SY': '%d/%m/%Y %T',
  'ar-TN': '%d-%m-%Y %H:%M',
  'ar-YE': '%d/%m/%Y %T',
  az: '%d.%m.%Y %H:%M',
  be: '%d.%m.yy %H:%M',
  'be-BY': '%d.%m.yy %H:%M',
  bg: "%-d.%m.%Y 'г.' %H:%M",
  'bg-BG': "%-d.%m.%Y 'г.' %H:%M",
  ca: '%-d/%M/%Y %H:%M',
  'ca-ES': '%-d/%M/%Y %H:%M',
  cs: '%d.%m.%Y %H:%M',
  'cs-CZ': '%d.%m.%Y %H:%M',
  da: '%d-%m-%Y %H:%M',
  'da-DK': '%d-%m-%Y %H:%M',
  de: '%d.%m.%Y %H:%M',
  'de-AT': '%d.%m.%Y %H:%M',
  'de-CH': '%d.%m.%Y %H:%M',
  'de-DE': '%d.%m.%Y %H:%M',
  'de-LI': '%d.%m.%Y %H:%M',
  'de-LU': '%d.%m.%Y %H:%M',
  dv: '%d/%m/yy %H:%M',
  'dv-MV': '%d/%m/yy %H:%M',
  el: '%-d/%M/%Y %T',
  'el-GR': '%-d/%M/%Y %T',
  en: '%m/%-d/%Y %T',
  'en-029': '%d/%m/%Y %H:%M',
  'en-AU': '%-d/%m/%Y %T',
  'en-BZ': '%d/%m/%Y %H:%M',
  'en-CA': '%Y-%m-%d %T',
  'en-GB': '%d/%m/%Y %H:%M',
  'en-IE': '%d/%m/%Y %H:%M',
  'en-JM': '%-d/%M/%Y %T',
  'en-NZ': '%-d/%m/%Y %T',
  'en-PH': '%d/%m/%Y %T',
  'en-TT': '%d/%m/%Y %T',
  'en-US': '%m/%-d/%Y %T',
  'en-ZA': '%Y/%m/%d %H:%M',
  'en-ZW': '%-d/%M/%Y %H:%M',
  es: '%d/%m/%Y %H:%M',
  'es-AR': '%-d/%M/%Y %H:%M',
  'es-BO': '%-d/%M/%Y %H:%M',
  'es-CL': '%d-%m-%Y %H:%M',
  'es-CO': '%-d/%m/%Y %T',
  'es-CR': '%-d/%M/%Y %H:%M',
  'es-DO': '%-d/%M/%Y %T',
  'es-EC': '%-d/%M/%Y %H:%M',
  'es-ES': '%d/%m/%Y %H:%M',
  'es-GT': '%-d/%m/%Y %H:%M',
  'es-HN': '%-d/%M/%Y %H:%M',
  'es-MX': '%d/%m/%Y %T',
  'es-NI': '%-d/%M/%Y %H:%M',
  'es-PA': 'MM/%d/%Y %T',
  'es-PE': '%-d/%m/%Y %H:%M',
  'es-PR': 'MM/%d/%Y %T',
  'es-PY': '%-d/%M/%Y %H:%M',
  'es-SV': '%-d/%M/%Y %H:%M',
  'es-UY': '%-d/%M/%Y %H:%M',
  'es-VE': '%-d/%M/%Y %T',
  et: '%d.%m.%Y %H:%M',
  'et-EE': '%d.%m.%Y %H:%M',
  eu: '%Y/%M/d %H:%M',
  'eu-ES': '%Y/%M/d %H:%M',
  fa: '%d/%m/%Y %T',
  'fa-IR': '%d/%m/%Y %T',
  fi: 'd.M.%Y %H.%m',
  'fi-FI': 'd.M.%Y %H.%m',
  fo: '%d.%m.%Y %H:%M',
  'fo-FO': '%d.%m.%Y %H:%M',
  fr: '%d/%m/%Y %H:%M',
  'fr-BE': '%d-%m-yy %H:%M',
  'fr-CA': '%Y-%m-%d %H:%M',
  'fr-CH': '%d.%m.%Y %H:%M',
  'fr-FR': '%d/%m/%Y %H:%M',
  'fr-LU': '%d/%m/%Y %H:%M',
  'fr-MC': '%d/%m/%Y %H:%M',
  gl: '%d/%m/%Y %H:%M',
  'gl-ES': '%d/%m/%Y %H:%M',
  gu: '%d-%m-yy %H:%M',
  'gu-IN': '%d-%m-yy %H:%M',
  he: '%d/%m/%Y %H:%M',
  'he-IL': '%d/%m/%Y %H:%M',
  hi: '%d-%m-%Y %H:%M',
  'hi-IN': '%d-%m-%Y %H:%M',
  hr: 'd.M.%Y. %H:%M',
  'hr-BA': 'd. M. %Y. %H:%M',
  'hr-HR': 'd.M.%Y. %H:%M',
  hu: '%Y. MM. %d. %H:%M',
  'hu-HU': '%Y. MM. %d. %H:%M',
  hy: '%d.%m.%Y %H:%M',
  'hy-AM': '%d.%m.%Y %H:%M',
  id: '%d/%m/%Y %HH.%m',
  'id-ID': '%d/%m/%Y %HH.%m',
  is: 'd.M.%Y %H:%M',
  'is-IS': 'd.M.%Y %H:%M',
  it: '%d/%m/%Y %H:%M',
  'it-CH': '%d.%m.%Y %H:%M',
  'it-IT': '%d/%m/%Y %H:%M',
  ja: '%Y/%m/%d %H:%M',
  'ja-JP': '%Y/%m/%d %H:%M',
  ka: '%d.%m.%Y %H:%M',
  'ka-GE': '%d.%m.%Y %H:%M',
  kk: '%d.%m.%Y %H:%M',
  'kk-KZ': '%d.%m.%Y %H:%M',
  kn: '%d-%m-yy %H:%M',
  'kn-IN': '%d-%m-yy %H:%M',
  ko: '%Y-%m-%d tt %H:%M',
  kok: '%d-%m-%Y %H:%M',
  'kok-IN': '%d-%m-%Y %H:%M',
  'ko-KR': '%Y-%m-%d tt %H:%M',
  ky: 'd-%mM yy %H:%M',
  'ky-KG': 'd-%mM yy %H:%M',
  lt: '%Y-%m-%d %H:%M',
  'lt-LT': '%Y-%m-%d %H:%M',
  lv: '%d.%m.%Y %H:%M',
  'lv-LV': '%d.%m.%Y %H:%M',
  mk: '%d.M.%Y %H:%M',
  'mk-MK': '%d.M.%Y %H:%M',
  mn: '%Y.%m.%d %H:%M',
  'mn-MN': '%Y.%m.%d %H:%M',
  mr: '%d-%m-%Y %H:%M',
  'mr-IN': '%d-%m-%Y %H:%M',
  ms: '%-d/%m/%Y %T',
  'ms-BN': '%-d/%m/%Y %T',
  'ms-MY': '%-d/%m/%Y %T',
  'nb-NO': '%d.%m.%Y %H:%M',
  nl: 'd-M-%Y %H:%M',
  'nl-BE': '%-d/%m/%Y %H:%M',
  'nl-NL': 'd-M-%Y %H:%M',
  'nn-NO': '%d.%m.%Y %H:%M',
  no: '%d.%m.%Y %H:%M',
  pa: '%d-%m-yy tt %H:%M',
  'pa-IN': '%d-%m-yy tt %H:%M',
  pl: '%d.%m.%Y %H:%M',
  'pl-PL': '%d.%m.%Y %H:%M',
  pt: '%d/%m/%Y %H:%M',
  'pt-BR': '%d/%m/%Y %H:%M',
  'pt-PT': '%d/%m/%Y %H:%M',
  ro: '%d.%m.%Y %H:%M',
  'ro-RO': '%d.%m.%Y %H:%M',
  ru: '%d.%m.%Y %H:%M',
  'ru-RU': '%d.%m.%Y %H:%M',
  sa: '%d-%m-%Y %H:%M',
  'sa-IN': '%d-%m-%Y %H:%M',
  sk: 'd. M. %Y %H:%M',
  'sk-SK': 'd. M. %Y %H:%M',
  sl: 'd. MM. %Y %H:%M',
  'sl-SI': 'd. MM. %Y %H:%M',
  sq: 'd.M.%Y %T',
  'sq-AL': 'd.M.%Y %T',
  sv: '%Y-%m-%d %H:%M',
  'sv-FI': '%d-%m-%Y %H:%M',
  'sv-SE': '%Y-%m-%d %H:%M',
  sw: '%d/%m/%Y %H:%M',
  'sw-KE': '%d/%m/%Y %H:%M',
  syr: '%d/%m/%Y %T',
  'syr-SY': '%d/%m/%Y %T',
  ta: '%d-%m-%Y %H:%M',
  'ta-IN': '%d-%m-%Y %H:%M',
  te: '%d-%m-yy %H:%M',
  'te-IN': '%d-%m-yy %H:%M',
  th: '%-d/%M/%Y %H:%M',
  'th-TH': '%-d/%M/%Y %H:%M',
  tr: 'd.%m.%Y %H:%M',
  'tr-TR': 'd.%m.%Y %H:%M',
  tt: '%d.%m.%Y %H:%M',
  'tt-RU': '%d.%m.%Y %H:%M',
  uk: '%d.%m.%Y %H:%M',
  'uk-UA': '%d.%m.%Y %H:%M',
  ur: '%d/%m/%Y %T',
  'ur-PK': '%d/%m/%Y %T',
  uz: '%d/%m/%Y %H:%M',
  vi: '%d/%m/%Y %T',
  'vi-VN': '%d/%m/%Y %T',
  'zh-CN': '%Y-%m-%d %T',
  'zh-HK': '%-d/%M/%Y %H:%M',
  'zh-MO': '%-d/%M/%Y %H:%M',
  'zh-SG': '%-d/%M/%Y %H:%M',
  'zh-TW': '%Y/%M/d %H:%M',
};
export default {
  data() {
    return { formats };
  },
  methods: {
    formatterArrayText(row, column, field) {
      if (!field || !field.length) return '--';
      return field.join('、');
    },
    formatterText(row, column, field) {
      return field || '--';
    },
    formatterNumber(row, column, field) {
      return typeof field === 'number' ? field : '--';
    },
    formatterPrice(row, column, field) {
      return typeof field === 'number' ? `￥${field.toFixed(2)}` : '--';
    },
    formatterDate(row, col, value) {
      // const locale = this.$i18n.locale;
      const format = 'YYYY-MM-DD HH:mm:ss';
      if (!value && !Number(value) && !(value instanceof Date)) {
        return '--';
      }

      return this.$moment(window.isNaN(window.Number(value)) || value instanceof Date ? value : value * 1).format(format);
    },
    formatterDateBirthday(row, col, value) {
      const format = 'MM-DD';
      if (!value) {
        return '--';
      }
      return this.$moment(window.isNaN(window.Number(value)) ? value : value * 1).format(format);
    },
  },
};
